// frontend/src/components/ArtworkPage/ArtworkDetails.js
import React from "react";
import { Link } from "react-router-dom";
import "./ArtworkDetails.css";


const ArtworkDetails = ({ artwork, currentIndex, totalCount }) => {
  // Get medium name
  const getMediumName = () => {
    if (typeof artwork.mediumId === "object" && artwork.mediumId?.name) {
      return artwork.mediumId.name;
    }
    // Fallback to old format if data hasn't been migrated
    return artwork.medium || "Unknown";
  };

  // Format dimensions
  const getDisplayDimensions = () => {
    // New format with width/height fields
    if (artwork.width && artwork.height) {
      const unit = artwork.unit || "in";
      return `${artwork.width} × ${artwork.height} ${unit}`;
    }

    // Old format with dimensions object (for backward compatibility)
    if (artwork.dimensions?.width && artwork.dimensions?.height) {
      const unit = artwork.dimensions.unit || "in";
      return `${artwork.dimensions.width} × ${artwork.dimensions.height} ${unit}`;
    }

    return null;
  };

  const mediumName = getMediumName();
  const dimensions = getDisplayDimensions();

  return (
    <div className="artwork-details">
      <div className="artwork-details-panel">
        <div className="artwork-details-header">
          <h1 className="artwork-details-title">{artwork.title}</h1>
          <p className="artwork-details-counter">
            {currentIndex + 1} of {totalCount}
          </p>
        </div>

        <div className="artwork-details-info">
          <div className="artwork-details-item">
            <h3 className="artwork-details-label">Medium</h3>
            <p className="artwork-details-value">{mediumName}</p>
          </div>

          {dimensions && (
            <div className="artwork-details-item">
              <h3 className="artwork-details-label">Size</h3>
              <p className="artwork-details-value">{dimensions}</p>

              {/* Availability Status */}
              {artwork.available === false && (
                <p className="artwork-details-availability sold">Sold</p>
              )}

              {artwork.available === true && (
                <p className="artwork-details-availability available">
                  Available for purchase.{" "}
                  <Link
                    to="/about#contact"
                    className="artwork-details-contact-link"
                  >
                    Contact me for details.
                  </Link>
                </p>
              )}
            </div>
          )}

          {/* <div className="artwork-details-item">
            <h3 className="artwork-details-label">Year</h3>
            <p className="artwork-details-value">{getYear(artwork.date)}</p>
          </div> */}

          {artwork.artist && artwork.artist !== "Unknown" && (
            <div className="artwork-details-item">
              <h3 className="artwork-details-label">Artist</h3>
              <p className="artwork-details-value">{artwork.artist}</p>
            </div>
          )}

          {artwork.description && (
            <div className="artwork-details-item">
              <h3 className="artwork-details-label">Description</h3>
              <p className="artwork-details-description">
                {artwork.description}
              </p>
            </div>
          )}
        </div>

        <div className="artwork-details-footer">
          <p className="artwork-details-hint">
            Use arrow keys or buttons to navigate between artworks
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArtworkDetails;
